/**
 * The seller page's only in-document trace of an out-of-date figure: a dotted
 * gold underline, no pill, no button. A public page or print never passes it.
 */
export const STALE_FIGURE_CLASS = `underline decoration-bp-gold decoration-dotted decoration-[3px] underline-offset-[0.12em]`

/** The same underline on every figure (tabular numbers) inside an element. */
export const STALE_FIGURES_WITHIN_CLASS = `[&_.tabular-nums]:underline [&_.tabular-nums]:decoration-bp-gold [&_.tabular-nums]:decoration-dotted [&_.tabular-nums]:decoration-[3px] [&_.tabular-nums]:underline-offset-[0.12em]`

/** What a screen reader hears in place of the underline. */
export const STALE_FIGURES_NOTE = `These figures are out of date.`
